import React, { Component } from 'react';
import CancelButton from '../blueprintWrappers/CancelButton';
import CurrentNotesContainer from '../../containers/notes/CurrentNotesContainer';

/**
 * Renders: {@link CurrentNotesContainer} and CancelButton
 * @props {function} closeOverlay
 * @returns CurrentNotesContainer, CancelButton
 */
class NotesOverlay extends Component {
	render() {
		const { closeOverlay } = this.props;
		return <div className="sales_lines_popover work_element_notes pt-card">
			<h3>Notes</h3>
			<CurrentNotesContainer />
			<br />
			<div className="pt-button-group pt-large pt-fill">
				<CancelButton
					display = { 'Close' }
					onClick = { closeOverlay } 
				/>
			</div>
		</div>
	}
}

export default NotesOverlay;


// WEBPACK FOOTER //
// ./src/components/notes/NotesOverlay.jsx